import { useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Form from "./components/Form";

import {
  useNotifyContext,
  NotifyType,
} from "../../../../contexts/NotifyContext";

import { Head } from "../../../../components/core";

const PricingLevelCreate = ({ breadcrumbs }: { breadcrumbs: Breadcrumb[] }) => {
  const { addNotify } = useNotifyContext();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const CREATE_PRICINGLEVEL = gql`
    mutation PricingLevelCreate(
      $name: String!
      $pricingMethodId: Int!
      $productType: Int
      $productIds: [Int!]
      $status: Boolean
    ) {
      pricingLevelCreate(
        input: {
          params: {
            name: $name
            pricingMethodId: $pricingMethodId
            productType: $productType
            productIds: $productIds
            status: $status
          }
        }
      ) {
        pricingLevel {
          id
          name
          pricingMethod {
            id
            name
          }
          productType
          products {
            id
            name
          }
          createdAt
          status
        }
      }
    }
  `;
  const [createPricingLevel] = useMutation(CREATE_PRICINGLEVEL);

  const handleSubmit = (
    values: any,
    actions: { setSubmitting: (arg0: boolean) => void }
  ) => {
    createPricingLevel({
      variables: {
        name: values.name,
        pricingMethodId: values.pricingMethod
          ? parseInt(values.pricingMethod.value)
          : null,
        productType: values.productType,
        productIds: values.productIds,
        status: values.status,
      },
    })
      .then(({ data }) => {
        actions.setSubmitting(false);
        if (data?.pricingLevelCreate) {
          addNotify({
            type: NotifyType.SUCCESS,
            title: "Pricing level created successfully",
          });
          return navigate(
            `/inventory/pricelist/pricing-levels/${data?.pricingLevelCreate?.pricingLevel?.id}`
          );
        } else {
          addNotify({
            type: NotifyType.ERROR,
            title: "Pricing level creation failed",
            message: "Something went wrong, please try again later",
          });
        }
      })
      .catch((error) => {
        actions.setSubmitting(false);
        addNotify({
          type: NotifyType.ERROR,
          title: "Pricing level creation failed",
          message: error.message,
        });
      });
  };

  return (
    <>
      <Head
        title="Create Pricing Level"
        heading="Pricing Levels"
        breadcrumbs={[
          ...breadcrumbs,
          {
            name: "Pricing Levels",
            href: "/inventory/pricelist/pricing-levels",
          },
          {
            name: PricingLevelCreateResource.name,
            href: null,
          },
        ]}
      />
      <div className="mx-auto max-w-3xl py-6 sm:py-8">
        <div className="rounded-xl bg-greyish p-5">
          <div className="mb-6 sm:flex sm:items-center md:mb-8">
            <div className="sm:flex-auto">
              <h1 className="text-xl font-medium text-gray-900">
                {t("heading_create_pricing_level")}
              </h1>
              <p className="mt-2 text-sm text-gray-700">
                {t("description_create_pricing_level")}
              </p>
            </div>
            {/* <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                <Link
                  to="/inventory/pricelist/pricing-levels/add"
                  className="inline-flex items-center justify-center rounded-md border border-transparent bg-primary-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 sm:w-auto"
                >
                  Add pricing level
                </Link>
              </div> */}
          </div>

          <Form
            initialValues={{
              name: "",
              pricingMethod: null,
              productType: 0,
              productIds: [],
              status: true,
            }}
            onSubmit={handleSubmit}
            actionLabel={t("text_create")}
          />
        </div>
      </div>
    </>
  );
};

export default PricingLevelCreate;
export const PricingLevelCreateResource: ResourceProps = {
  name: "Create Pricing Level",
  description: "Create a new pricing level",
  access: ["create-pricinglevels"],
  path: "pricing-levels/add",
};
